import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { StaticTextCustomization } from './staticitext-edit';

@Component({
  selector: 'lib-statictext-compiled',
  imports: [ReactiveFormsModule],
  template: `
    @let widget = widgetService.widget();
    @if (widget) {
      <div class="flex w-full flex-col">
        @if (widget.customization.title) {
          <div class="break-all">
            {{ widget.customization.title }}
          </div>
        }
        @if (widget.customization.description) {
          <div class="w-full">
            <div
              [innerHTML]="widget.customization.description"
              class="prose max-w-full break-all"
            ></div>
          </div>
        }
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class StaticTextCompiledComponent {
  protected widgetService = inject(
    CompilingWidgetService<StaticTextCustomization>,
  );
}
